import { portalPaths } from '@provision/portal-routes';
import { ReactElement, useCallback, useMemo } from 'react';
import { Address } from 'src/graphql/entities/address/address';

import { ConditionInput, EntityNames } from 'src/graphql/types';
import { BaseSelectedView } from 'src/pages/CustomViews/custom-views-selected-view/base-selected-view';
import { TabType, useCustomView, useGlobalTabs } from 'src/utils/hooks';
import { useNavigateRoute } from 'src/utils/routing';
import { Platform } from 'src/utils/system';

export const ExpandedSites = ({
  viewFilters,
  viewId,
  customViewType,
  createButton,
}: {
  viewFilters: ConditionInput[];
  viewId: string;
  customViewType: EntityNames;
  createButton?: ReactElement;
}) => {
  const { navigate } = useNavigateRoute();
  const { openInTab } = useGlobalTabs();
  const customViewId = useCustomView(customViewType)?.customViewId;
  const onRecordClick = useCallback(
    <T extends Address>(_: T['id'], record: T, event?: React.MouseEvent) => {
      if (Platform.isMacOS ? event?.metaKey : event?.ctrlKey) {
        openInTab({ type: TabType.Site, entity: record }, { customViewId }, false);
        return;
      }
      navigate(portalPaths.site.full(record.addressId), { state: { customViewId } });
    },
    [customViewId, navigate, openInTab],
  );

  const slots = useMemo(
    () => ({
      createButton,
    }),
    [createButton],
  );

  return (
    <BaseSelectedView<Address>
      isStaticView
      entity={EntityNames.Site}
      viewId={viewId}
      onRecordClick={onRecordClick}
      viewFilters={viewFilters}
      title="Sites"
      leftHeaderAdornment=""
      slots={slots}
    />
  );
};
